import { LuFileText } from "react-icons/lu";
import Footer from "../../../../shared/components/footer";
import Navbar from "../../../../shared/components/navbar";
import PageContent from "../../../../shared/components/PageContent";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import QuoteStepHeading from "../../../../shared/components/QuoteStepHeading";
import AccordionGroup from "../../../../shared/components/accordionGroup";
import PortalBackButton from "../../components/PortalBackButton";
import PageContentStack from "../../../../shared/components/PageContentStack";

const PortalDocuments = () => {
  const STATE = useAppStateStore();
  const { archiveItems, archiveItemsActionLinks } = STATE.documents || {};
  const documentGroups = (archiveItemsActionLinks || [])
    .map((actionLink) => ({
      ...actionLink,
      items: (archiveItems || []).filter((item) =>
        actionLink.linkedVaultArchiveItems?.includes(item.archiveId)
      ),
    }))
    .filter((group) => group.items.length > 0);
  const hasDocuments = documentGroups.length > 0;

  return (
    <>
      <Navbar />
      <PageContent>
        <PageContentStack>
          <QuoteFormWrapper>
            <QuoteStepHeading
              title="Portal Documents"
              description={
                hasDocuments
                  ? "View and download your policy documents below."
                  : "Your policy documents will be available here."
              }
            />

            {hasDocuments ? (
              <div className="tw-flex tw-flex-col tw-gap-5">
                {documentGroups.map((group, index) => (
                  <AccordionGroup
                    key={`${group.archiveActionLinkName}-${index}`}
                    header={group.archiveActionLinkName}
                    items={group.items}
                  />
                ))}
              </div>
            ) : (
              <div className="tw-flex tw-items-start tw-gap-3 tw-border-x-0 tw-border-y tw-border-solid tw-border-dis-divider tw-py-4">
                <LuFileText
                  className="tw-mt-0.5 tw-h-5 tw-w-5 tw-shrink-0 tw-text-dis-deep-blue"
                  aria-hidden="true"
                />
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <h2 className="tw-m-0 tw-text-base tw-font-semibold tw-text-dis-navy">
                    No documents available yet
                  </h2>
                  <p className="tw-m-0 tw-text-dis-small tw-leading-[1.5] tw-text-dis-text-muted">
                    When your policy documents are ready, you’ll be able to view and
                    download them here.
                  </p>
                </div>
              </div>
            )}
          </QuoteFormWrapper>
          <PortalBackButton />
        </PageContentStack>
      </PageContent>
      <Footer />
    </>
  );
};

export default PortalDocuments;
